<div class="word-wall">

    <div class="title" id="wordwall-title">
        Word Wall
    </div>

    <div class="balloon" id="wordwall-balloon">
        <span class="balloon-text" *ngIf="isRecording"
              [ngStyle]="{'font-size': getBalloonFontSize(wordWallRecordingService.currentItem)}">
            {{wordWallRecordingService.currentItem.text}}
        </span>
    </div>

    <div class="row">
        <div class="col-xs-12 volume pb-1">
        
            <div class="col-xs-12">
                <div class="icn-wall-volume">
                    <div class="volume-title">Volume</div>
                </div>
                <div class="col-xs-12 img-volume-feedback-overlay-parent">
                    <div *ngFor="let vol of volumeBar; let i = index;" [ngClass] = "vol.volume ? 'img-volume-feedback-bar-dark' : 'img-volume-feedback-bar'"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">

        <ul class="list-group col-md-5 ml-3 p-0"
            *ngFor="let table of wordWallTableFormats">
            <li class="list-group-item wall-item"
                *ngFor="let itemIndex of table.ngForIndices">
                <button class="btn btn-record-small"
                        *ngIf="getText(itemIndex) !== '' && !itemIsComplete(itemIndex) && !wordWallRecordingService.isGuided"
                        [disabled]="clickDisabled"
                        (click)="record(itemIndex)">
                </button>
                <button class="btn btn-check-small"
                        *ngIf="getText(itemIndex) !== '' && itemIsComplete(itemIndex)"
                        [disabled]="clickDisabled"
                        (click)="record(itemIndex)">
                </button>
                <button class="btn btn-placeholder"
                        *ngIf="getText(itemIndex) === ''">
                </button>

                <span class="item-span" (click)="glossary(itemIndex)"
                      *ngIf="!clickDisabled"
                      >{{ getText(itemIndex) }}</span>
                <span class="item-span-disabled"
                      *ngIf="clickDisabled"
                      >{{ getText(itemIndex) }}</span>
            </li>
        </ul>


    </div>

    <div class="wordwall-start-button text-center btn-group btn-group-lg-align-center mt-1">
        <button class="blue-button btn-lg do-flash" *ngIf="showBlinkingButton"
                (click)="finishWordWall()">
                <span class="start-button">Start</span>
        </button>
        <button class="blue-button btn-lg" *ngIf="showButton"
                (click)="finishWordWall()">
                <span class="start-button">Start</span>
        </button>
    </div>

</div>
